import React from 'react';
import { motion } from 'framer-motion';
import Header from '../Header';
import { PageContainer } from '../PageContainer';

interface MessagesPageLayoutProps {
  sidebar: React.ReactNode;
  detail: React.ReactNode;
  isMobile: boolean;
  onMenuClick?: () => void;
}

export const MessagesPageLayout: React.FC<MessagesPageLayoutProps> = ({
  sidebar,
  detail,
  isMobile,
  onMenuClick
}) => {
  return (
    <motion.div
      className="bg-muted flex flex-col relative w-full h-screen overflow-hidden"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
    >
      {/* Header - consistent across all layouts */}
      <Header className="shrink-0 w-full" onMenuClick={onMenuClick} />

      {/* Master-Detail Layout (Desktop) */}
      {!isMobile && (
        <PageContainer className="flex-1 min-h-0 flex-row !px-0">
          <div className="flex flex-1 min-h-0 w-full overflow-hidden">
            {/* Sidebar: Thread List with filter and search */}
            <div className="hidden md:flex flex-col w-[640px] border-r border-border bg-muted shrink-0 overflow-hidden">
              {sidebar}
            </div>

            {/* Detail Pane: Thread content + orders panel */}
            <div className="flex-1 flex flex-col min-w-0 min-h-0 bg-background">
              {detail}
            </div>
          </div>
        </PageContainer>
      )}

      {/* Mobile Layout - Single column */}
      {isMobile && (
        <PageContainer className="flex-1 min-h-0 !px-0">
          {sidebar}
        </PageContainer>
      )}
    </motion.div>
  );
};

export default MessagesPageLayout;
